import TabViewState, { TabType } from '../store/schema/TabViewState';
import { getStore } from '../store/tabStore';
import { trace } from 'owa-trace';

export default function getActiveContentTab(): TabViewState {
    const store = getStore();

    for (const viewState of store.tabs) {
        if (viewState.isActive && viewState.type != TabType.FloatingChat) {
            return viewState;
        }
    }

    // We should never see this happen.
    trace.error('There is no active tab. Something went very wrong.');
    return null;
}
